<template>
  <div class="mail-params">
    <el-row>
      <el-col :span="12">
        {{ $t("app.username") }}:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.username"
        >
        </el-input>
      </el-col>
      <el-col :span="12">
        {{ $t("app.emailHost") }}:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.emailHost"
        >
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        {{ $t("app.userAddress") }}:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.userAddress"
        >
        </el-input>
      </el-col>

      <el-col :span="12">
        {{ $t("app.emailHostPort") }}:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.emailHostPort"
        >
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-checkbox v-model="childrenData.needAuthenticate"
          >是否需驗證</el-checkbox
        >
      </el-col>
      <el-col :span="12">
        {{ $t("app.password") }}:
        <el-input
          type="password"
          size="small"
          style="width: 250px"
          v-model="childrenData.password"
        >
        </el-input>
      </el-col>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          userAddress: "",
          username: "",
          emailHost: "",
          emailHostPort: "",
          password: "",
          needAuthenticate: false,
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    reset() {
      this.childrenData.username = "";
      this.childrenData.emailHost = "";
      this.childrenData.userAddress = "";
      this.childrenData.emailHostPort = "";
      this.childrenData.needAuthenticate = false;
      this.childrenData.password = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.mail-params {
  min-height: 150px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
